export default __webpack_public_path__ + "static/fire_door_b.297dee5b0b8bcbce0355a3514d7bfb4c.svg";